import React from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as EditIcon } from "../../../../../assets/images/icon-edit-tooltip.svg";
import { useStyles } from "../styles"
export function TooltipContentMarkup() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (<p className={classes.TooltipTexPartOne}>{t("menu.extras.TooltipTitlePart1")} <span><EditIcon /></span>
  {t("menu.extras.TooltipTitlePart2")}
  </p>)
}
